import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { AuthService } from '../../../../shared/libs/auth/auth.service';
import { Router } from '@angular/router';
import { URLS_GUARD } from '../../../../shared/libs/models/url-guard.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs';

@Component({
	standalone: false,
	selector: 'bt-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	readonly #authService = inject(AuthService);
	readonly #router = inject(Router);
	readonly #destroyRef = inject(DestroyRef);

	ngOnInit(): void {
		if (this.#authService.userLoggedValue) {
			const url = this.#authService.isCompany() ? URLS_GUARD.COMPANY : URLS_GUARD.PHOTOGRAPHER;
			this.#router.navigate([url]);
		}
		this.check();
	}

	check(): void {
		this.#authService
			.getJwtToken()
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				switchMap((res: any) => {
					return this.#authService.authentication(this.#router.routerState.snapshot).pipe(takeUntilDestroyed(this.#destroyRef));
				})
			)
			.subscribe({
				error: (err: any) => {}
			});
	}

	goToLogin(): void {
		this.#authService.login();
	}

	requestCredentials(): void {}
}
